/**
 * Parinaam staff, for the pickers that have to name a colleague.
 *
 * Deliberately not the admin account list: that one carries email addresses and
 * password state and is refused to a coordinator. This is names and roles,
 * which staff already see on every screen.
 *
 * Cached for a long time on purpose. The set of colleagues changes when
 * somebody joins or leaves, which is not a thing that happens while a dropdown
 * is open.
 */

import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../services/api/client';

export interface StaffAccount {
  user_id: string;
  display_name: string;
  role: 'ADMIN' | 'TEAM';
}

export const staffAccountKeys = { all: ['users', 'staff'] as const };

export function useStaffAccounts() {
  return useQuery<StaffAccount[]>({
    queryKey: staffAccountKeys.all,
    queryFn: () => apiGet<StaffAccount[]>('/users/staff'),
    staleTime: 10 * 60 * 1000,
  });
}
